/**
 * AdminOnlySection — wraps sections the student does not see, so an admin or
 * teacher reading the analysis can tell which parts of the LLM output never
 * reached the student. Dims and italicises the content and prefixes a short
 * "not shown to student" marker.
 *
 * The marker is unconditional, so callers must only mount this when the
 * wrapped section actually has data — the section atoms return `null` when
 * empty, which would otherwise leave a bare marker behind.
 */
import type { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    /** Names the section in a heading — "Diagnosis (not shown to student)" —
     *  in place of the bare marker. */
    title?: string;
}

export function AdminOnlySection({ children, title }: Props) {
    return (
        <div className="sol-admin-only">
            {title ? (
                <h3 className="sol-section-title sol-admin-only-title">
                    {title} <span className="sol-admin-only-note">(not shown to student)</span>
                </h3>
            ) : (
                <span className="sol-admin-only-tag">Not shown to student</span>
            )}
            {children}
        </div>
    );
}
